<form class="container-fluid" [formGroup]="Entry">
  <div class="row row-padding justify-content-center">
    <div class="col-auto">
      <label class="fs-32">Reset Password</label>
    </div>
  </div>

  <div class="row row-padding justify-content-center">
    <div class="col-4">
      <div class="row">
        <div class="col">
          <label>Password</label>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <app-password-field
            [passwordFormControl]="Entry.controls['password']"
          ></app-password-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <label>Confirm Password</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-password-field
            [passwordFormControl]="Entry.controls['passwordConfirm']"
          ></app-password-field>
        </div>
      </div>
    </div>

    <div class="col-4">
      <app-password-validator
        [password]="Entry.controls['password'].value"
        [passwordConfirm]="Entry.controls['passwordConfirm'].value"
        (passwordValidationErrors)="passwordErrorEvent.emit($event)"
      ></app-password-validator>
    </div>
  </div>
</form>
